import { getSearch } from "@/tracker/shared/global";

/**
 * 构建搜索相关的URL参数
 * @param {string} searchWord - 搜索词
 * @param {Object} options - 可选参数
 * @param {Object} options.searchData - 搜索数据，如果不传则从getSearch()获取
 * @returns {string} URL参数字符串
 *
 * @example
 * // 基本用法
 * const params = buildSearchParams("设计");
 *
 * // 传入自定义搜索数据
 * const params = buildSearchParams("设计", {
 *   searchData: {
 *     search_word_type: "手动输入搜索词",
 *     search_type: "搜索栏-搜索",
 *     original_search_word: "设计",
 *     top_label_list: ["UI", "平面"],
 *     top_label_depth: 2
 *   }
 * });
 */
export function buildSearchParams(searchWord, options = {}) {
  const searchData = options.searchData || getSearch();
  const params = [];

  // 从getSearch获取搜索相关字段
  if (searchWord) params.push(`search_word=${encodeURIComponent(searchWord)}`);
  if (searchData?.search_word_type)
    params.push(
      `search_word_type=${encodeURIComponent(searchData?.search_word_type)}`
    );
  if (searchData?.search_result_number)
    params.push(
      `search_result_number=${encodeURIComponent(
        String(searchData?.search_result_number)
      )}`
    );
  if (searchData?.search_type)
    params.push(`search_type=${encodeURIComponent(searchData?.search_type)}`);
  if (searchData?.original_search_word)
    params.push(
      `original_search_word=${encodeURIComponent(
        searchData?.original_search_word
      )}`
    );
  if (searchData?.top_label_list) {
    const labelList = Array.isArray(searchData?.top_label_list)
      ? JSON.stringify(searchData?.top_label_list)
      : searchData?.top_label_list;
    params.push(`top_label_list=${encodeURIComponent(labelList)}`);
  }
  if (searchData?.top_label_depth)
    params.push(
      `top_label_depth=${encodeURIComponent(
        String(searchData?.top_label_depth)
      )}`
    );

  // 添加埋点追踪参数
  params.push(`isNeedTrack=true`);

  return params.join("&");
}
